import React, { useState, useEffect, useRef } from 'react'
import styles from './ImageInput.module.css'
import PropTypes from 'prop-types'
import Button from '../../Button/Base'
import PhotoIcon from '../../../legacy_components/Icons/Profile/PhotoIcon'
import CloseIcon from '../../../legacy_components/Icons/CloseIcon'

const ACCEPTED_MIME_TYPES = [
  'image/jpeg',
  'image/png',
  'image/gif',
]

const MAX_FILE_SIZE = 2000000

const ImageInput = ({
  name,
  value,
  onChange,
  required = false,
  disabled = false,
  'aria-label': ariaLabel,
}) => {
  const ref = useRef(null)
  const [ imageSrc, setImageSrc] = useState(null)

  useEffect(() => {
    setImageSrc(!value
      ? null
      : value instanceof File ? URL.createObjectURL(value) : value.href)
  }, [value])

  const handleChange = e => {
    const file = e.target.files[0]

    if (file && (ACCEPTED_MIME_TYPES.indexOf(file.type) < 0 || file.size > MAX_FILE_SIZE)) {
      return
    }

    onChange(file)
  }

  const handleReset = () => {
    onChange(null)
  }

  const handleClick = event => {
    event.stopPropagation()
    event.preventDefault()

    if (ref && ref.current) {
      ref.current.click()
    }
  }

  return (
    <div className={ styles.wrapper }>
      <div className={ styles['inner-wrapper'] }>
        <button className={ styles.button } aria-label={ ariaLabel } onClick={ handleClick }>
          { imageSrc
            ? <img src={ imageSrc } alt="" aria-hidden={ true } />
            : <PhotoIcon />
          }
        </button>
        { !required && null !== value
          ? <div className={ styles['remove-image'] }>
            <Button onClick={ handleReset }>
              <CloseIcon width={ 12 } height={ 12 } />
            </Button>
          </div>
          : null
        }
        <input
          ref={ ref }
          className={ styles.input }
          type="file"
          name={ name }
          onChange={ handleChange }
          required={ required }
          disabled={ disabled }
          accept={ ACCEPTED_MIME_TYPES.join(',') }
          size={ MAX_FILE_SIZE }
          aria-label={ ariaLabel }
        />
      </div>
    </div>
  )
}

ImageInput.propTypes = {
  name: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([
    PropTypes.shape({
      href: PropTypes.string.isRequired,
    }),
    PropTypes.instanceOf(File),
  ]),
  onChange: PropTypes.func.isRequired,
  required: PropTypes.bool,
  disabled: PropTypes.bool,
  'aria-label': PropTypes.string.isRequired,
}

export default ImageInput
